module.exports = __webpack_public_path__ + "img/data-item2-3.33cf911.png";